import React, { useEffect } from 'react'
import PropTypes from 'prop-types'

import { useSurveyContext } from '../_store'
import { Loading, Onboarding } from './_pages'

// Check if the survey has a landing page to show before starting
// If we want to skip the landing page, check if param 'start' is true and show a loading screen instead of landing
// If starting the survey fails, show the error (see specific landing pages and Loading.js)
const Landing = ({ type }) => {
  const { actions } = useSurveyContext()
  const params = new URLSearchParams(window.location.search)
  // Skip landing page if we are auto-starting the survey
  const landing = params.get('start') === 'true' ? null : type
  let page

  switch (landing) {
    case 'onboarding':
      page = <Onboarding />
      break
    default:
      page = null
  }

  // Only call actions.start() once!
  useEffect(() => {
    if (!page) actions.start()
  }, [])

  return page || <Loading />
}

Landing.propTypes = {
  type: PropTypes.string
}

export default Landing
